import mixpanel from 'mixpanel-browser'

export function track(event: string, properties?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  mixpanel.track(event, properties)
}

export function identify(userId: string, traits?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  mixpanel.identify(userId)
  if (traits) mixpanel.people.set(traits)
}

export function reset() {
  if (typeof window === 'undefined') return
  mixpanel.reset()
}
